<template>
    <div aria-live="assertive" class="pointer-events-none fixed inset-0 flex justify-end items-end px-4 py-6 sm:p-6 z-[9999999]">
        <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
            <transition
                enter-active-class="transform ease-out duration-300 transition"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div
                    v-if="show"
                    class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
                >
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="flex-shrink-0">
                                <component 
                                    :is="icons[toast.type]" 
                                    :class="iconClasses[toast.type]"
                                    class="h-6 w-6" 
                                    aria-hidden="true" 
                                />
                            </div>
                            <div class="ml-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium text-gray-900" v-html="toast.title"/>
                                <p v-if="toast.description" class="mt-1 text-sm text-gray-500" v-html="toast.description"/>
                            </div>
                            <div class="ml-4 flex flex-shrink-0">
                                <button
                                    type="button"
                                    class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                    @click="hideToast"
                                >
                                    <span class="sr-only">Close</span>
                                    <XMarkIcon class="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon, XCircleIcon } from '@heroicons/vue/24/outline';
import { XMarkIcon } from '@heroicons/vue/20/solid';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'GlobalToast',
    
    components: {
        CheckCircleIcon,
        ExclamationTriangleIcon,
        InformationCircleIcon,
        XCircleIcon,
        XMarkIcon
    },

    data() {
        return {
            icons: {
                success: CheckCircleIcon,
                error: XCircleIcon,
                warning: ExclamationTriangleIcon,
                info: InformationCircleIcon
            },
            iconClasses: {
                success: 'text-green-400',
                error: 'text-red-400',
                warning: 'text-yellow-400',
                info: 'text-blue-400'
            }
        };
    },

    computed: {
        ...mapState('toast', {
            toast: state => state.toast,
            show: state => state.show
        })
    },

    methods: {
        ...mapActions('toast', ['hideToast'])
    }
};
</script> 